export const content = `You can view your payment and session history together in your account.

## On mobile

1. When you login to your account, use the menu icon to open your navigation menu.
2. Select [**Payments**](/payments).
3. Your payment and session history should appear. If it doesn’t, select the [**Payments**](/payments/overview) tab.

## On desktop

1. When you login to your account, go to [**Payments**](/payments) from your sidebar navigation.
2. Your payment and session history should appear. If it doesn’t, select the [**Payments**](/payments/overview) tab.
`;
